<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="5" :sm="24">
            <a-form-item label="姓名">
              <a-input placeholder="请输入" v-model="queryParam.name" />
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="24">
            <a-form-item label="部门">
              <a-tree-select
                showSearch
                :value="queryParam.orgCode"
                :treeData="departmentTree"
                :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
                placeholder="请选择部门"
                allowClear
                treeNodeFilterProp="title"
                treeDefaultExpandAll
                @change="onChangeDep"
              >
              </a-tree-select>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="24">
            <a-form-item label="角色">
            <a-select v-model="queryParam.roleId" allowClear>
              <a-select-option :value="item.id" v-for="item of rolelist" :key="item.id">{{ item.name }}</a-select-option>
            </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" icon="search" @click="getUserPage">查询</a-button>
            </span>
          </a-col>
          <a-col :md="3" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" icon="plus" @click="handleAdd" v-if="permissions.includes('back:user:add')">添加用户</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <br />
    <a-table
      rowKey="userId"
      :columns="columns"
      :dataSource="userlist"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      bordered
    >
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)" v-if="permissions.includes('back:user:update')">编辑</a>
        <a-divider type="vertical" v-if="permissions.includes('back:user:update')" />
        <a @click="handleChangePassword(record.userId)" v-if="permissions.includes('back:user:password')">修改密码</a>
        <a-divider type="vertical" v-if="permissions.includes('back:user:password')" />
        <a-dropdown>
          <a class="ant-dropdown-link">
            更多
            <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a @click="handleDetail(record)">详情</a>
            </a-menu-item>
            <a-menu-item v-if="permissions.includes('back:user:delete')">
              <a-popconfirm
                :title="`确定删除${record.name}吗?`"
                @confirm="() => handleRemove(record.userId)"
                okText="确定" 
                cancelText="取消"
              >
                <a>删除</a>
              </a-popconfirm>
            </a-menu-item>
            <a-menu-item v-if="record.enable&&permissions.includes('back:user:delete')">
              <a-popconfirm
                :title="`确定禁用${record.name}吗?`"
                @confirm="() => handleFrozen(record.userId, 'lock')"
                okText="确定" 
                cancelText="取消"
              >
                <a>禁用</a>
              </a-popconfirm>
            </a-menu-item>
            <a-menu-item v-if="!record.enable&&permissions.includes('back:user:delete')">
              <a-popconfirm
                :title="`确定启用${record.name}吗?`"
                @confirm="() => handleFrozen(record.userId, 'unlock')"
                okText="确定" 
                cancelText="取消"
              >
                <a>启用</a>
              </a-popconfirm>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
      <span slot="enable" slot-scope="text, record" :class="text ? '' : 'state' ">
        {{ text ? '启用' : '禁用' }}
      </span>
    </a-table>

    <user-modal ref="usermodal" :departmentTree="departmentTree" :rolelist="rolelist" @ok="userModalOk"></user-modal>
    <password-modal ref="passwordmodal" ></password-modal>

  </a-card>
</template>

<script>
import { getUserPage, removeUser, frozenUserBatch } from '@/baseAPI/user'
import { getRoleSelect } from '@/baseAPI/role'
import { queryDepartmentTreeList } from '@/baseAPI/department'
import UserModal from './modules/UserModal'
import PasswordModal from './modules/PasswordModal'
import { mapState } from 'vuex'

export default {
  name: 'UserList',
  components: {
    UserModal,
    PasswordModal
  },
  computed: {
    ...mapState({
      permissions: state => state.user.permissions
    })
  },
  data () {
    return {
      departmentTree: [],
      rolelist: [],
      loading: false,
      // 查询参数
      queryParam: {
        name: '',
        orgCode: '',
        roleId: ''
      },
      pagination: {},
      columns: [
        {
          title: '序号',
          dataIndex: 'serialnum'
        },
        {
          title: '登入名',
          dataIndex: 'userId'
        },
        {
          title: '姓名',
          dataIndex: 'name'
        },
        // {
        //   title: '角色',
        //   dataIndex: 'sysRoleNameStr'
        // },
        {
          title: '部门',
          dataIndex: 'orgName'
        },
        {
          title: '岗位',
          dataIndex: 'position'
        },
        {
          title: '状态',
          dataIndex: 'enable',
          scopedSlots: { customRender: 'enable' }
        },
        {
          title: '最后登入时间',
          dataIndex: 'lastLoginTime'

        },
        {
          title: '操作',
          width: '220px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      userlist: []
    }
  },
  mounted () {
    this.getUserPage()
    queryDepartmentTreeList().then((res) => {
      this.departmentTree = res.data
    })
    getRoleSelect().then((res) => {
      this.rolelist = res.data
    })
  },
  methods: {
    onChangeDep (value) {
      this.queryParam.orgCode = value
    },
    handleTableChange(pagination) {
      const pager = { ...this.pagination }
      pager.current = pagination.current
      pager.pageSize = pagination.pageSize
      this.pagination = pager
      this.getUserPage()
    },
    getUserPage() {
      this.loading = true
      const params = Object.assign({ size: this.pagination.pageSize, current: this.pagination.current },this.queryParam)
      getUserPage(params).then(res => {
        const pagination = { ...this.pagination }
        pagination.total = res.data.total
        this.loading = false
        this.userlist = res.data.records
        this.userlist.forEach((item, index) => item.serialnum = (res.data.current - 1) * 10 + index + 1)
        this.pagination = pagination
      })
    },
    handleDetail (record) {
      this.$refs.usermodal.show(1, Object.assign({}, record))
    },
    handleEdit (record) {
      this.$refs.usermodal.show(2, Object.assign({}, record))
    },
    handleAdd () {
      this.$refs.usermodal.show(3, {})
    },
    handleChangePassword (id) {
      this.$refs.passwordmodal.show(id)
    },
    handleFrozen (id, status) {
      const _this = this
      frozenUserBatch(id, status)
        .then(res => {
          _this.$notification.success({
            message: '提示',
            description: res.message || '操作成功',
            duration: 3
          })
          this.getUserPage()
        })
        .catch(err => {
          _this.$notification.error({
            message: '错误',
            description: ((err.response || {}).data || {}).message || '操作失败',
            duration: 3
          })
        })
    },
    handleRemove (id) {
      removeUser(id)
        .then(res => {
          this.$notification.success({
            message: '提示',
            description: res.message || '删除用户成功',
            duration: 3
          })
          this.getUserPage()
        })
        .catch(err => {
          this.$notification.error({
            message: '错误',
            description: ((err.response || {}).data || {}).message || '删除用户失败',
            duration: 3
          })
        })
    },
    userModalOk () {
      this.getUserPage()
    }
  }
}
</script>
<style scoped>
  a{
    display: inline-block;
    text-decoration: none;
    color: #1F5EFF;
  }
  .ant-select, .ant-input{
    width: 200px;
  }
  .state{
    color: red;
  }
</style>
